import { render, staticRenderFns } from "./EventosPuntoVenta.vue?vue&type=template&id=f44a8256"
import script from "./EventosPuntoVenta.vue?vue&type=script&lang=js"
export * from "./EventosPuntoVenta.vue?vue&type=script&lang=js"
import style0 from "./EventosPuntoVenta.vue?vue&type=style&index=0&id=f44a8256&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports